import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { EditableDBItemV3, ModuleFE_MouseInteractivity, ProtoComponent, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend/index';
import { TS_HorizontalWorkspace, TS_Workspace } from '@nu-art/ts-workspace-frontend/index';
import { DBDef_FHIRQuery, DBDef_FHIRResource, newFHIRResourceTemplate } from '@app/fhir-shared';
import { cloneObj, DefaultNewItemId, exists, resolveContent } from '@nu-art/ts-common';
import { getFHIRManagerSearchItems, workspaceKey_FHIRManager } from './consts.js';
import { SearchSelector_BaseManagerUI } from '@app/styles';
import { ModuleFE_FHIRQuery, ModuleFE_FHIRResource } from '../../_entity.js';
import { Editor_FHIRResource } from './Editor_FHIRResource/Editor_FHIRResource.js';
import { Editor_FHIRQuery } from './Editor_FHIRQuery/Editor_FHIRQuery.js';
import './Page_FHIRManager.scss';
import { newFHIRQueryTemplate } from '../../_entity/fhir-query/consts.js';
export class Page_FHIRManager extends ProtoComponent {
    static defaultProps = {
        keys: ['selected', 'searchItem'],
    };
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.searchItems = getFHIRManagerSearchItems();
        //Get selectedSearchItem from url
        const selected = this.getQueryParam('selected', {});
        //Get selected search item
        state.selectedSearchItem = undefined;
        for (const searchItem of state.searchItems) {
            const selectedId = selected[searchItem.type];
            if (!exists(selectedId))
                continue;
            state.selectedSearchItem = { type: searchItem.type, id: selectedId };
            break;
        }
        return state;
    }
    // ######################## Logic ########################
    onSearchItemSelected = (item) => {
        const selected = { ...this.getQueryParam('selected', {}) };
        //Clear all selections under this manager
        this.state.searchItems.forEach(searchItem => delete selected[searchItem.type]);
        //Set the selected item
        selected[item.type] = item.id;
        this.setQueryParams({
            selected: selected,
            searchItem: item.type, //Switch the filters in the search panel to the item type
        });
    };
    createNewItem = (dbKey) => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
        this.onSearchItemSelected({ type: dbKey, id: DefaultNewItemId });
    };
    getEditable = (module, newItemBase) => {
        const id = this.state.selectedSearchItem?.id;
        if (!id)
            return;
        const selectedItem = module.cache.unique(id) ?? cloneObj(resolveContent(newItemBase));
        const editable = new EditableDBItemV3(selectedItem, module);
        editable.setAutoSave(selectedItem._id !== DefaultNewItemId);
        editable.setDebounceTimeout(300);
        editable.setOnSaveCompleted(item => {
            //If the item is newly created, simulate selection for it
            if (id === DefaultNewItemId)
                return this.onSearchItemSelected({ type: module.dbDef.dbKey, id: item._id });
            //Item is not newly created, re-render
            this.forceUpdate();
        });
        return editable;
    };
    deselectItem = (dbKey) => {
        const selected = { ...this.getQueryParam('selected', {}) };
        delete selected[dbKey];
        this.setQueryParam('selected', selected);
    };
    // ######################## Render ########################
    render() {
        return _jsx(TS_Workspace, { workspaceKey: workspaceKey_FHIRManager, renderers: {
                horizontalSpace: TS_HorizontalWorkspace,
            }, instances: {
                list: () => this.renderList(),
                editor: () => this.renderEditor(),
            } });
    }
    renderList = () => {
        return _jsx(SearchSelector_BaseManagerUI, { buttons: [{
                    label: 'Add New',
                    action: (e) => {
                        const buttonBox = e.currentTarget.getBoundingClientRect();
                        const model = {
                            id: 'page-fhir-manager__add-new-popup',
                            originPos: {
                                x: buttonBox.right + 10,
                                y: buttonBox.top,
                            },
                            modalPos: { x: 1, y: 1 },
                            content: () => _jsx(_Fragment, { children: this.state.searchItems.map(searchItem => _jsx("div", { onClick: () => this.createNewItem(searchItem.type), children: searchItem.entityLabel }, searchItem.type)) }),
                        };
                        ModuleFE_MouseInteractivity.showContent(model);
                    }
                }], searchItems: this.state.searchItems, onSearchItemSelected: this.onSearchItemSelected, selectedItem: this.state.selectedSearchItem });
    };
    renderEditor = () => {
        const dbKey = this.state.selectedSearchItem?.type;
        switch (dbKey) {
            case DBDef_FHIRResource.dbKey:
                return this.renderEditor_FHIRResource();
            case DBDef_FHIRQuery.dbKey:
                return this.renderEditor_FHIRQuery();
            default:
                return _jsx(_Fragment, {});
        }
    };
    renderEditor_FHIRResource = () => {
        const editable = this.getEditable(ModuleFE_FHIRResource, newFHIRResourceTemplate);
        if (!editable)
            return _jsx(_Fragment, {});
        return _jsx(Editor_FHIRResource, { editable: editable, deselectResource: () => this.deselectItem(DBDef_FHIRResource.dbKey) });
    };
    renderEditor_FHIRQuery = () => {
        const editable = this.getEditable(ModuleFE_FHIRQuery, newFHIRQueryTemplate);
        if (!editable)
            return _jsx(_Fragment, {});
        return _jsx(Editor_FHIRQuery, { editable: editable, deselectQuery: () => this.deselectItem(DBDef_FHIRQuery.dbKey) });
    };
}
//# sourceMappingURL=Page_FHIRManager.js.map